//import * as XLSX from "xlsx";
import Papa from "papaparse";

const DEFAULT_MATCH_KEYS = [
  "Phone",
  "Telefono",
  "msisdn",
  "NUMERO",
  "numero",
  "phone",
  "telefono",
  "celular",
  "cel",
  "movil",
  "contacto",
  "contact",
  "número",
  "tel",
  "teléfono",
  "whatsapp",
  "wa",
  "Phone 1",
];

class ReadFile {
  constructor(base64, callbacks = {}, workerFactory = null, validate = {}) {
    this.base64 = base64;
    this.onInit = callbacks.onInit;
    this.onComplete = callbacks.onComplete;
    this.workerFactory =
      workerFactory ||
      (() =>
        new Worker(new URL("../../../workers/cvs.worker.js", import.meta.url), {
          type: "module",
        }));

        this.validate = validate;
  }

  // obtener los headers
  headerRows() {
    return new Promise((resolve, reject) => {
      Papa.parse(this.base64, {
        preview: 1,
        header: true,
        complete: (results) => {
          const data = results.data;
          const uniqueKeys = [
            ...new Set(data.flatMap((obj) => Object.keys(obj))),
          ];
          resolve(uniqueKeys);
        },
        error: (error) => {
          reject(error);
        },
      });
    });
  }

  async newData(data, ignoreHeaders) {
    const headers = await this.headerRows();

    const newHeaders = headers.filter(
      (header) => !ignoreHeaders.includes(header)
    );

    return data.map((obj) => {
      const newObj = {};
      newHeaders.forEach((header) => {
        newObj[header] = obj[header];
      });
      return newObj;
    });
  }

  async generateNewCSV(data = []) {
    const csv = Papa.unparse(data);

    return new Blob([csv], { type: "text/csv;charset=utf-8;" });
  }
  async generate() {
    return new Promise((resolve, reject) => {
      const allData = [];
      let validData = [];
      let invalidData = [];

      const worker = this.workerFactory();

      worker.onmessage = (event) => {
        const { type, data, error } = event.data;

        switch (type) {
          case "init_process":
            this.onInit?.();
            break;
          case "chunk":
            allData.push(...data);
            break;
          case "invalid_chunk":
            invalidData.push(...data);
            break;
          case "valid_chunk":
            validData.push(...data);
            break;
          case "complete":
            worker.terminate();
            this.onComplete?.();
            resolve({ summary: event.data, allData, validData, invalidData });
            break;
          case "error":
            worker.terminate();
            reject(error);
            break;
        }
      };

      worker.postMessage({
        file: this.base64,
        config: {
          matchKeys: DEFAULT_MATCH_KEYS,
          email: this.validate.email ?? false,
        },
      });
    });
  }
}

export default ReadFile;
